import type { TournamentState } from '@ps/poker-games-tile-mappers';
import classNames from 'clsx';
import React from 'react';

import PriorityImage from '../../PriorityImage/PriorityImage';
import type { Tag } from '../TournamentInfo/Tags/Tags';
import Tags from '../TournamentInfo/Tags/Tags';

import NameBar from './NameBar/NameBar';
import State from './State/State';
import styles from './TournamentCard.scss';

export interface TournamentCardProps {
  state: TournamentState;
  tournamentName?: string;
  tags?: Tag[];
  imageUrl: string;
  fallbackImageUrl: string;
  className?: string;
}

const TournamentCard: React.FC<TournamentCardProps> = ({
  state,
  tournamentName,
  tags,
  imageUrl,
  fallbackImageUrl,
  className = ''
}) => (
  <div className={classNames(styles.root, className)}>
    <State state={state} className={styles.state} />
    <PriorityImage
      imageUrl={imageUrl}
      fallbackUrl={fallbackImageUrl}
      altText={tournamentName || ''}
      fetchPriority={'high'}
      className={styles.image}
    />
    {!!tournamentName && <NameBar tournamentName={tournamentName} className={styles.nameBar} />}
    {!!tags && <Tags tags={tags} className={styles.tags} />}
  </div>
);

export default TournamentCard;
